export type JurisdictionId = 'DEFAULT' | 'CN'

// Any missing or unrecognised value resolves to DEFAULT, so global builds are
// unaffected. NOTE: the id must be uppercase 'CN' — any other casing silently
// resolves to DEFAULT.
export const resolveJurisdictionId = (raw: unknown): JurisdictionId => (raw === 'CN' ? 'CN' : 'DEFAULT')

// Resolves the jurisdiction the same way the open-fe shell does: the runtime
// window.__WPP_CONFIG__.jurisdictionId wins, falling back to the build-time
// REACT_APP_JURISDICTION (baked into the bundle by CRA/webpack; the CN
// deployment build exports it before running the build). The try/catch
// degrades safely in runtimes where window or process is unavailable.
const readJurisdictionId = (): JurisdictionId => {
  try {
    return resolveJurisdictionId(window.__WPP_CONFIG__?.jurisdictionId ?? process.env.REACT_APP_JURISDICTION)
  } catch {
    return 'DEFAULT'
  }
}

// Evaluated once at module load. Business code should not compare this directly —
// consume the semantic flags in utils/features.ts instead, so jurisdiction
// conditions live in one place.
export const JURISDICTION_ID: JurisdictionId = readJurisdictionId()
